// @flow

// Libs
import React from 'react'

// Components
import SvgIcon from './SvgIcon'
import svg from 'material-design-icons/editor/svg/production/ic_insert_chart_24px.svg'

// Types
type Props = {
  size?: number,
  color?: string,
  style?: Object,
}

// Exports
export default function BarChart ({size = 24, color = 'rgb(0, 0, 0)', style = {}}: Props): React.Element<any> {
  return (
    <SvgIcon
      size={size}
      color={color}
      src={svg}
      style={style}
    />
  )
}
